import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'
import { logEnvironmentInfo, appVersion, buildTime } from './lib/env'

// Expose version info to window object for DevTools access
if (typeof window !== 'undefined') {
  (window as any).__APP_VERSION__ = appVersion;
  (window as any).__BUILD_TIME__ = buildTime;
  (window as any).__APP_INFO__ = {
    version: appVersion,
    buildTime: buildTime,
    environment: import.meta.env.MODE,
  };
}

// Log environment info (only in non-production)
logEnvironmentInfo()

// Dev tools - rate limiter reset (only in development)
if (import.meta.env.DEV) {
  import('./lib/resetRateLimit')
  // Cookie/storage debugging tools (exposed as window.__DEBUG_STORAGE__)
  import('./lib/cookieDebug')
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)

